// Import the zustand store instance
import useQuoteStore from "../store/QuoteStore";
import useAppStateStore from "../../../shared/store/AppStateStore";

const Tq6Mapper = {
  get() {
    const STATE = useAppStateStore.getState();
    // Get fresh data when getting values
    const vehicle = useQuoteStore.getState().quote?.risk?.vehicles[0] ?? {};
    const claims = STATE.claims;

    return {
      RegOwner: vehicle.ownerId
        ? vehicle.ownerId === "1"
          ? "Yes"
          : "No"
        : null,
      owner: vehicle.ownerId ? { value: vehicle.ownerId } : "",
      Regkeeper: vehicle.keeperId
        ? vehicle.keeperId === "1"
          ? "Yes"
          : "No"
        : null,
      keeper: vehicle.keeperId ? { value: vehicle.keeperId } : "",
      marketValue: vehicle.estimatedValue === 0 ? null : vehicle.estimatedValue,
      overNightHome: vehicle.overnightParkingId
        ? vehicle.overnightParkingId === "4"
          ? "Yes"
          : "No"
        : null,
      locOverNight:
        vehicle.overnightParkingId && vehicle.overnightParkingId !== "4"
          ? { value: vehicle.overnightParkingId }
          : null,
      overNightPostcode: vehicle?.garageAddress?.postcode ?? null,
      AdditionalClaims5Years: claims ?? null,
    };
  },

  set(data) {
    const { updateField } = useQuoteStore.getState();
    const STATE = useAppStateStore.getState();
    const setClaims = STATE.setClaims;
    const driver = useQuoteStore.getState().quote?.risk?.drivers?.[0] ?? {};
    if (data.RegOwner == "No") {
      updateField("risk.vehicles.0.ownerId", data.owner?.value ?? "1");
    }
    if (data.RegOwner == "Yes") {
      updateField("risk.vehicles.0.ownerId", "1");
    }
    if (data.Regkeeper == "No") {
      updateField("risk.vehicles.0.keeperId", data.keeper?.value ?? "1");
    }
    if (data.Regkeeper == "Yes") {
      updateField("risk.vehicles.0.keeperId", "1");
    }
    updateField("risk.vehicles.0.estimatedValue", data.marketValue);
    if (data.overNightHome == "No") {
      updateField(
        "risk.vehicles.0.overnightParkingId",
        data.locOverNight?.value
      );
    }
    if (data.overNightHome == "Yes") {
      updateField("risk.vehicles.0.overnightParkingId", "4");
    }

    updateField("risk.vehicles.0.garageAddress", {
      ...useQuoteStore.getState().quote?.risk?.vehicles[0]?.garageAddress,
      postcode: data.overNightPostcode ?? driver.address?.postcode ?? "",
      // If it's home address, copy other fields from driver's address
      ...(data.overNightHome === "Yes"
        ? {
            postcode: driver.address?.postcode ?? "",
            houseNo: driver.address?.houseNo ?? "",
            street: driver.address?.street ?? "",
            locality: driver.address?.locality ?? "",
            city: driver.address?.city ?? "",
            county: driver.address?.county ?? "",
          }
        : {}),
    });

    updateField(
      "risk.cover.drivingRestrictionId",
      data.drivingRestrictionId ?? ""
    );
    updateField("risk.cover.requestedVolExcess", data.volAccess?.label ?? 0);
    updateField(
      "risk.cover.requestedVolExcessId",
      data.volAccess?.value ?? "00"
    );
    updateField("risk.cover.previousInsurance", data.previousInsurance ?? null);
    setClaims(data.AdditionalClaims5Years);
  },
};

export default Tq6Mapper;
